import { PostingsPageContextProvider } from '../../core/postings/PostingsPageContext';
import { PostingListPage } from './PostingListPage';

export function PostingListPageContainerPage() {
  return (
    <PostingsPageContextProvider>
      <PostingListPage />
    </PostingsPageContextProvider>
  );
}
